const namespace = 'axios-debounce';

function getCurrentState(config) {
  const currentState = config[namespace] || {};
  config[namespace] = currentState; // eslint-disable-line no-param-reassign
  return currentState;
}

const debounceCache = {};

export default function axiosDebounce(axios) {
  axios.interceptors.request.use((config) => {
    const { id } = getCurrentState(config);
    if (id) {
      const source = axios.CancelToken.source();
      if (config.cancelToken) {
        // eslint-disable-next-line
        config.cancelToken.promise.then((cancel) => { source.cancel(cancel.message); });
      }
      config.cancelToken = source.token; // eslint-disable-line no-param-reassign
      if (debounceCache[id]) {
        debounceCache[id].source.cancel(`axios-debounced '${id}'`);
      }
      debounceCache[id] = {
        source,
        cancelToken: config.cancelToken,
      };

      return config;
    }
    return config;
  });

  axios.interceptors.response.use((response) => {
    const { config } = response;
    if (!config) return response;

    const { id } = getCurrentState(config);
    if (id) {
      const { cancelToken } = config;
      const { cancelToken: sourceCancelToken } = debounceCache[id] || {};
      if (cancelToken !== sourceCancelToken) {
        return Promise.reject(new axios.Cancel(`axios-debounced '${id}'`));
      }
      delete debounceCache[id];
    }

    return response;
  }, (error) => {
    const { config } = error;
    if (!config) return Promise.reject(error);

    const { id } = getCurrentState(config);
    if (id) {
      const { cancelToken } = config;
      const { cancelToken: sourceCancelToken } = debounceCache[id] || {};
      if (cancelToken !== sourceCancelToken) {
        return Promise.reject(new axios.Cancel(`axios-debounced '${id}'`));
      }
      delete debounceCache[id];
    }
    return Promise.reject(error);
  });
}
